import {useMediaQuery} from 'react-responsive'

export const useScreenType = () => {
  const isDesktop = useMediaQuery({minWidth: 1600})
  const isLaptop = useMediaQuery({minWidth: 1300})
  const isTablet = useMediaQuery({minWidth: 900})
  const isMobile = useMediaQuery({maxWidth: 900})

  if (isDesktop) {
    return 'desktop'
  }

  if (isLaptop) {
    return 'laptop'
  }

  if (isTablet) {
    return 'tablet'
  }

  if (isMobile) {
    return 'mobile'
  }

  return 'desktop'
}
